export const UNEXPECTED_ERROR = '予期せぬエラーが発生しました。時間をおいて再度お試しください。'
